import { Box, Switch, Text } from '@rsos/base-components';
import styled from '@rsos/theme/styled';

const Item = styled(Box).attrs({
  horizontal: true,
  justify: 'space-between',
  align: 'center',
  padding: '0 8px',
})`
&:hover {
  background-color: ${({ theme }) => theme.colors.highlights};
`;

interface FlagOverrideItemProps {
  flagKey: string;
  flagValue: boolean;
  onClick: (flagKey: string, flagValue: boolean) => void;
}

const FlagOverrideItem = ({
  flagKey,
  flagValue,
  onClick,
}: FlagOverrideItemProps) => {
  return (
    <Item key={flagKey}>
      <Text size="normal" color="primaryText">
        {flagKey}
      </Text>
      <Switch
        isOn={Boolean(flagValue)}
        disabled={flagKey === 'debug-panel'}
        onClick={() => onClick(flagKey, !flagValue)}
      />
    </Item>
  );
};

export default FlagOverrideItem;
